import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { AppEventService } from '../../core/event/app-event.service';

export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const eventService = inject(AppEventService);

  return next(req).pipe(
    tap({
      error: (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (!(err.status === 401 && (err.message === '' || (err.url && err.url.includes('api/account'))))) {
            eventService.broadcast({ name: 'leanbyteApp.httpError', content: err });
          }
        }
      }
    })
  );
};
